// page-backlog-review-types.ts — Ce que l'écran de revue reçoit du serveur.
//
// Extrait de `page-backlog-review.ts` le 2026-09-13, quand l'écran a été
// découpé en zones (constat, liste, gestes, menus). Chaque zone lit les mêmes
// structures : elles vivent ici, une fois, plutôt que recopiées par module.
//
// Le seul comportement de ce fichier est `label` — le libellé traduit d'un code
// métier, que les quatre zones composent de la même façon.

import type { RunLike } from './page-backlog-review-run.js';

export interface Target {
  type: string;
  id: number;
  role?: string;
}
export interface Change {
  field: string;
  label: string;
  before: unknown;
  after: unknown;
  at?: string;
  by_trigram?: string | null;
}
export interface Reco {
  id: number;
  is_new?: boolean;
  family: string;
  targets: Target[];
  title: string;
  rationale: string;
  evidence: Record<string, unknown>;
  confidence: string;
  provenance: string;
  pile: string;
  to_arbitrate: boolean;
  annotation: string | null;
  committee_outcome: string | null;
  committee_date: string | null;
  committee_comment: string | null;
  resurfaced_reason: string | null;
  no_longer_detected_at: string | null;
  row_version: number;
  unavailable?: boolean;
  changed_since_analysis?: boolean;
  changes?: Change[];
}
export type Run = RunLike;
export interface Anomaly {
  code: string;
  count: number;
  total: number;
  pct: number;
  target?: string;
}
export interface Review {
  id: number;
  title: string | null;
  scope_type: string;
  created_at: string | null;
  created_by_trigram: string | null;
  limit_recommendations: boolean;
  iterations_count: number;
  label: string;
  status: string;
  constat: Record<string, unknown>;
  constat_computed_at: string | null;
  recommendations: Reco[];
  drift: { analysed: number; created_unanalysed: number; left_perimeter: number };
  run: Run | null;
  // Les supports produits. Leur seule utilité ici : ouvrir la saisie du retour
  // de comité — on ne saisit un retour que sur ce qui a été présenté.
  supports: Array<{ id: number; filename: string; generated_at: string | null }>;
  // Ce qui a l'air anormal dans ce qu'une source non fiable a produit. Recalculé
  // par le serveur à chaque lecture, donc il suit les arbitrages.
  anomalies: Anomaly[];
}

/** « review.family.fusion » → « Fusion ». */
export function label(prefix: string, code: string): string {
  return t(`${prefix}.${code}`);
}
